import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  searchMobilityFailure,
  searchMobilitySuccess,
  searchReviewSnapshotsFailure,
  searchReviewSnapshotsSuccess,
  searchReviewLogsFailure,
  searchReviewLogsSuccess,
  searchCarePlanFailure,
  searchCarePlanSuccess,
  searchWarningFailure,
  searchWarningSuccess,
  searchMappedPlanFailure,
  searchMappedPlanSuccess,
} from "./actions";
import {
  SEARCH_MOBILITY,
  SEARCH_REVIEW_SNAPSHOTS,
  SEARCH_REVIEW_LOGS,
  SEARCH_CARE_PLAN,
  SEARCH_WARNING,
  SEARCH_MAPPED_PLAN,
} from "./constants";

export function* searchMobilitySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, filters } = payload;
  let query = filters ? QueryString.stringify(filters) : "";

  try {
    const { data } = yield call(
      api(token).get,
      `/api/observation-log/${residentId}?${query}`,
    );
    yield put(searchMobilitySuccess(data));
  } catch (e) {
    yield put(searchMobilityFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching blog!"));
  }
}

export function* searchReviewSnapshotsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, params } = payload;
  let query = params ? QueryString.stringify(params) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident/tool-chart-snapshot/${residentId}?${query}`,
    );
    yield put(searchReviewSnapshotsSuccess(data));
  } catch (e) {
    yield put(searchReviewSnapshotsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching review snapshots!"));
  }
}

export function* searchReviewLogsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, params } = payload;
  let query = params ? QueryString.stringify(params) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/observation-log/${residentId}?${query}`,
    );
    yield put(searchReviewLogsSuccess(data));
  } catch (e) {
    yield put(searchReviewLogsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching review logs!"));
  }
}

export function* searchCarePlanSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, params } = payload;
  let query = params ? QueryString.stringify(params) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident/care-plan-response/${residentId}?${query}`,
    );
    yield put(searchCarePlanSuccess(data));
    if (callback) callback(data);
  } catch (e) {
    yield put(searchCarePlanFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching care plan!"));
  }
}

export function* searchWarningSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { params } = payload;
  let query = params ? QueryString.stringify(params) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/care-plan-warning-alert?${query}`,
    );
    yield put(searchWarningSuccess(data));
    if (callback) callback(data);
  } catch (e) {
    yield put(searchWarningFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching warning!"));
  }
}

export function* searchMappedPlanSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId } = payload;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident/latest-care-plan/${residentId}`,
    );
    yield put(searchMappedPlanSuccess(data));
    if (callback) callback(data);
  } catch (e) {
    yield put(searchMappedPlanFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching mapped plan!"));
  }
}

export function* searchMobilityFlow() {
  yield takeEvery(SEARCH_MOBILITY, searchMobilitySaga);
}

export function* searchReviewSnapshotsFlow() {
  yield takeEvery(SEARCH_REVIEW_SNAPSHOTS, searchReviewSnapshotsSaga);
}

export function* searchReviewLogsFlow() {
  yield takeEvery(SEARCH_REVIEW_LOGS, searchReviewLogsSaga);
}

export function* searchCarePlanFlow() {
  yield takeEvery(SEARCH_CARE_PLAN, searchCarePlanSaga);
}

export function* searchWarningFlow() {
  yield takeEvery(SEARCH_WARNING, searchWarningSaga);
}

export function* searchMappedPlanFlow() {
  yield takeEvery(SEARCH_MAPPED_PLAN, searchMappedPlanSaga);
}
export default function* SearchSaga() {
  yield all([
    searchMobilityFlow(),
    searchReviewSnapshotsFlow(),
    searchReviewLogsFlow(),
    searchCarePlanFlow(),
    searchWarningFlow(),
    searchMappedPlanFlow(),
  ]);
}
